import React from "react";
import PickList from "../../../../form/operationlist/PickList";

export default (propsTop) => {
    const {props, state, parent} = propsTop;
    const {hidden, labels, pool, operationitems} = props;
    return props.values[props.componentConfig.idfield] && <PickList
        loading={props.isLoading}
        ref={(el) => parent.picklist = el}
        className={"p-small-table"}
        data={props.values}
        saveChanges={props.setFieldValue}
        source={{
            ...pool
        }}
        onSourceItemUpdate={parent.onSourceItemUpdate}
        onTransferItems={parent.onTransferItems}
        onTargetItemUpdate={parent.onTargetItemUpdate}
        target={{
            ...operationitems,
            componentConfig: props.componentConfig,
            ...(!!props.actions ? {selection: {}} : {})
        }}
        {...props.getProps("items")}
    />
}